<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cleNKP/tc-custom/9781613769225.jpg?1724816535428" alt="This image is the cover for the book California Days of Ralph Waldo Emerson"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">California Days of Ralph Waldo Emerson
      </h1>
      <p class="bookDescription body article font2">
        <b>“A vivid and painstakingly researched account of Emerson’s late-in-life, seven-week trek across the North American continent in 1871.” —<i>New York Review of Books</i></b><br/><br/>In the spring of 1871, Ralph Waldo Emerson boarded a train in Concord, Massachusetts, bound for a month-and-a-half-long tour of California—an interlude that became one of the highlights of his life. On their journey across the American West, he and his companions would take in breathtaking vistas in the Rockies and along the Pacific Coast, speak with a young John Muir in the Yosemite Valley, stop off in Salt Lake City for a meeting with Brigham Young, and encounter a diversity of communities and cultures that would challenge their Yankee prejudices.<br/><br/>Based on original research employing newly discovered documents, <i>The California Days of Ralph Waldo Emerson</i> maps the public story of this group’s travels onto the private story of Emerson’s final years, as aphasia set in and increasingly robbed him of his words. Engaging and compelling, this travelogue makes it clear that Emerson was still capable of wonder, surprise, and friendship, debunking the presumed darkness of his last decade.<br/><br/>“Wilson effectively conveys Emerson’s cultural myopia, along with its late-Victorian context.” —<i>Times Literary Supplement</i><br/><br/>“Deeply researched, enjoyably readable.” —<i>San Francisco Chronicle</i><br/><br/>“What Wilson offers the Emersonian reader today is a unique story of Emerson in motion, having a particularly American experience in looking westward.” —<i>Emerson Society Papers</i><br/><br/>“A welcome addition to Emerson scholarship and the first comprehensive treatment of his journey westward to the Pacific state.” —Ronald A. Bosco, general editor of <i>The Collected Works of Ralph Waldo Emerson</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian C. Wilson
      </h2>
      
      <p class="authorDescription body article">BRIAN C. WILSON is professor of comparative religion at Western Michigan University and author of <I>John E. Fetzer and the Quest for the New Age</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Massachusetts Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f772d976